module.exports = __webpack_public_path__ + "img/Frame 2137.0362a3a8.png";